module.exports = __webpack_public_path__ + "static/media/collage_GLP.bc40b27f.jpg";